var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.activeView === "form"
    ? _c("div", { staticClass: "row", attrs: { id: "form-content" } }, [
        _c("div", { staticClass: "col-12 pt-2" }, [
          _c("p", {
            staticClass: "lead fw-bold",
            domProps: { innerHTML: _vm._s(_vm.dto.formContent.title) },
          }),
          _vm._v(" "),
          _c("p", {
            staticClass: "small fw-bold mb-0",
            domProps: { innerHTML: _vm._s(_vm.dto.formContent.text) },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _vm.showAlertMessage
              ? _c("AlertMessage", {
                  staticClass: "ob1-alert",
                  attrs: {
                    title: _vm.dto.formContent.error,
                    type: "warning",
                    "with-alert-role": "",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("TextField", {
              attrs: {
                "model-value": _vm.phoneLineValue,
                label: _vm.dto.formContent?.phoneLineTextField || "",
                anonymized: true,
                "helper-text": "10 chiffres commençant par 01 à 09",
                "label-id": "phone-line-label",
                "input-id": "phone-line-input",
                "type-value": "text",
                "input-mode-value": "tel",
                "is-full-width-input": true,
                "error-message": _vm.phoneLineErrorMessage,
                "is-invalid": !!_vm.phoneLineErrorMessage,
                "is-required": true,
                "max-length": 10,
              },
              on: {
                change: function ($event) {
                  return _vm.onPhoneLineChange($event)
                },
              },
            }),
            _vm._v(" "),
            _c("TextField", {
              attrs: {
                "model-value": _vm.customerCodeValue,
                label: _vm.dto.formContent?.customerCodeTextField || "",
                anonymized: true,
                "helper-text": "10 chiffres",
                "label-id": "customer-code-label",
                "input-id": "customer-code-input",
                "type-value": "text",
                "input-mode-value": "numeric",
                "is-full-width-input": true,
                "error-message": _vm.customerCodeErrorMessage,
                "is-invalid": !!_vm.customerCodeErrorMessage,
                "is-required": true,
                "max-length": 10,
              },
              on: {
                change: function ($event) {
                  return _vm.onCustomerPidChange($event)
                },
              },
            }),
            _vm._v(" "),
            _c("Lien", {
              attrs: {
                id: "show-info",
                href: "#",
                "is-button": false,
                "is-mini": true,
                "is-link-arrow": false,
                label: _vm.dto.formContent.infoLink.label,
                "data-oevent-category":
                  _vm.dto.formContent.infoLink.tms.category,
                "data-oevent-action": _vm.dto.formContent.infoLink.tms.action,
                "data-oevent-label": _vm.dto.formContent.infoLink.tms.label,
              },
              on: { click: _vm.showInfo },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }